import { Tooltip } from '@radix-ui/themes';
import type { ReactNode } from 'react';

export interface FoodyTooltipProps {
  content: ReactNode;
  children: ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
  delayDuration?: number;
}

export function FoodyTooltip({
  content,
  children,
  side = 'top',
  delayDuration = 200,
}: FoodyTooltipProps) {
  return (
    <Tooltip content={content} side={side} delayDuration={delayDuration}>
      {children}
    </Tooltip>
  );
}
